<div :class="$style.uploader">
  <div :class="$style.uploaderProcessing" v-if="uploading">
    <animation-processing :class="$style.spinner"></animation-processing>
  </div>
  <div v-if="!uploading">
    <div id="qq-graphics-uploader-zone">
      <div
        :id="$vId(this, 'choose')"
        class="qq-uploader-selector qq-upload-button-selector"
        :class="$style.uploadZone">
        <UploadIcon :class="$style.uploadZoneIcon"/>
        <div>
          <div :class="$style.uploadZoneTitle" v-html="$t('pages.submissions.components.upload.uploader.drag_zone.title')"></div>
        </div>
        <div
          class="qq-upload-drop-area-selector"
          :class="$style.uploadZoneArea" qq-hide-dropzone>
          <span class="qq-upload-drop-area-text-selector"></span>
        </div>
        <ul
          class="qq-upload-list-selector"
          role="region"
          aria-live="polite"
          aria-relevant="additions removals">
        </ul>
      </div>
    </div>
  </div>
</div>